export const parseCautionText = (text: string): string[] =>
  text
    .trim()
    .split('\n')
    .map(x => (x === '\r' || x === '' ? '<br>' : x))
    .map(x => x.trim())
    .map(x => (x.endsWith('。') ? x.slice(0, -1) : x))
    .filter(x => x?.length > 0)

export const parseProhibitionText = (text: string): string[] =>
  text
    .trim()
    .split('\n')
    .map(x => (x === '\r' || x === '' ? '<br>' : x))
